import {createAction} from 'Shared/utilities/actionCreator';
import {
  changeHasAhlAccess,
  changeNewYorkAccess,
  changeRecruiterCode,
  EmptyFieldSalesLeaderUserType,
  FieldSalesLeaderUserType,
} from 'Users/models/User/Agent/FieldSalesLeaderUserType';

export enum FieldSalesLeaderUserTypeActionType {
  CHANGE_RECRUITER_CODE = 'fieldSalesLeaderUserType/CHANGE_RECRUITER_CODE',
  CHANGE_AHL = 'fieldSalesLeaderUserType/CHANGE_AHL',
  CHANGE_NEW_YORK = 'fieldSalesLeaderUserType/CHANGE_NEW_YORK',
}

export const changeFieldSalesLeaderRecruiterCode = (
  recruiterCode: string,
  isAhlRecruiterCode: boolean,
  isNewYorkRecruiterCode: boolean
) =>
  createAction(FieldSalesLeaderUserTypeActionType.CHANGE_RECRUITER_CODE, {
    recruiterCode,
    isAhlRecruiterCode,
    isNewYorkRecruiterCode,
  });
export const changeFieldSalesLeaderAHL = (isAhl: boolean) =>
  createAction(FieldSalesLeaderUserTypeActionType.CHANGE_AHL, {isAhl});
export const changeFieldSalesLeaderNewYork = (newYork: boolean) =>
  createAction(FieldSalesLeaderUserTypeActionType.CHANGE_NEW_YORK, {newYork});

type FieldSalesLeaderUserTypeState = FieldSalesLeaderUserType;
const DEFAULT_STATE = EmptyFieldSalesLeaderUserType;

export type FieldSalesLeaderUserTypeAction =
  | ReturnType<typeof changeFieldSalesLeaderRecruiterCode>
  | ReturnType<typeof changeFieldSalesLeaderAHL>
  | ReturnType<typeof changeFieldSalesLeaderNewYork>;

export default (
  state: FieldSalesLeaderUserTypeState = DEFAULT_STATE,
  action: FieldSalesLeaderUserTypeAction
): FieldSalesLeaderUserTypeState => {
  switch (action.type) {
    case FieldSalesLeaderUserTypeActionType.CHANGE_RECRUITER_CODE:
      const {recruiterCode, isAhlRecruiterCode, isNewYorkRecruiterCode} = action.payload;

      return changeRecruiterCode(recruiterCode, isAhlRecruiterCode, isNewYorkRecruiterCode);
    case FieldSalesLeaderUserTypeActionType.CHANGE_AHL:
      const {isAhl} = action.payload;

      return changeHasAhlAccess(isAhl)(state);
    case FieldSalesLeaderUserTypeActionType.CHANGE_NEW_YORK:
      const {newYork} = action.payload;

      return changeNewYorkAccess(newYork)(state);
  }
};
